/* eslint-disable react/require-default-props */
import { Grid, fade, makeStyles, Typography } from '@material-ui/core';
import { mergeClasses } from '@material-ui/styles';
import React from 'react';
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: fade(theme.palette.primary.light, 0.3),
        border: `2px dashed ${theme.palette.primary.light}`,
        borderRadius: theme.spacing(3),
        marginTop: 'auto',
    },
    inner: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    title: {
        padding: theme.spacing(1, 2),
        backgroundColor: theme.palette.common.white,
        border: `2px dashed ${theme.palette.primary.light}`,
        borderRadius: theme.spacing(2),
        width: 'max-content',
        height: 'max-content',
        marginTop: '-16px',
    },
    body: { padding: theme.spacing(3), fontWeight: 400 },
}));
const DashedDescription = ({ title, body, classes: newClasses, }) => {
    const baseClasses = useStyles();
    const allClasses = mergeClasses({
        Component: DashedDescription,
        baseClasses,
        newClasses: newClasses,
    });
    return (React.createElement(Grid, { container: true, className: allClasses.root },
        React.createElement(Grid, { container: true, direction: 'column', className: allClasses.inner },
            React.createElement(Typography, { variant: 'subtitle2', color: 'textPrimary', className: allClasses.title }, title),
            React.createElement(Typography, { variant: 'caption', color: 'textPrimary', className: allClasses.body }, body))));
};
export default DashedDescription;
